import React from 'react'
import Site from './Site'
import MapContainer from '../mapContainer/MapContainer'

export default class Dosquebradas extends React.Component {
  render() {
    return (
      <div>
        <Site dep="Risaralda" mun="Santa Rosa de Cabal" dir="Kilómetro 3, vía  Santa Rosa de Cabal - Dosquebradas, sector Alto de Boquerón." tel="314 670 0122" />
        <MapContainer lat={4.8583743} lng={-75.6370004} zoom={16.95}></MapContainer>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/sites/Dosquebradas.jsx